import { CloseOutlined } from '@ant-design/icons'
import { ITymberEcommStore } from '@getgreenline/blaze-ecomm'
import { Switch } from 'antd'
import { inject } from 'mobx-react'
import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { IRetailerToggleMessage, LocationWithConfig } from './EcommerceSettingModels'

interface IRetailerConfigSwitchProps {
  locations: LocationWithConfig[]
  locationId: number
  retailerToggleError: IRetailerToggleMessage | null
  isWaitingUpdate: boolean
  disabled?: boolean
  locallyUpdateConfig: (updatedConfig: ITymberEcommStore) => void
  setIsModalVisible: Dispatch<SetStateAction<boolean>>
  useModalLocationState: [
    LocationWithConfig | null,
    Dispatch<SetStateAction<LocationWithConfig | null>>,
  ]
  currentCompanyStore?: CurrentCompanyStore
}

export const RetailerConfigSwitch: FC<IRetailerConfigSwitchProps> = inject('currentCompanyStore')(
  ({
    locations,
    locationId,
    retailerToggleError,
    isWaitingUpdate,
    disabled,
    setIsModalVisible,
    useModalLocationState,
  }: IRetailerConfigSwitchProps) => {
    const [hasError, setHasError] = useState(false)
    const [modalLocation, setModalLocation] = useModalLocationState
    const location = locations.find((_location) => _location.id === locationId)
    const isEnabled = location?.config?.attributes.isActive

    useEffect(() => {
      setHasError(retailerToggleError?.retailerId === locationId)
    }, [retailerToggleError])

    function invokeModal() {
      if (location) setModalLocation(location)
      setIsModalVisible(true)
    }

    return (
      <Switch
        unCheckedChildren={hasError && <CloseOutlined />}
        checkedChildren={hasError && <CloseOutlined />}
        checked={isEnabled}
        disabled={isWaitingUpdate || disabled}
        loading={isWaitingUpdate && modalLocation?.id === locationId}
        onChange={invokeModal}
        style={{
          backgroundColor: `${hasError ? 'var(--red)' : ''}`,
          animation: `background-color .2s ease`,
        }}
      />
    )
  },
)
